import { getImageUrl } from '../../../utils/helpers'

interface GalleryItem {
  id: number
  file_name: string
  file_path: string
  mime_type: string
  file_size: number
  title: string
  description: string | null
  category_id: number | null
  category_name: string | null
  show_in_gallery: boolean
  url: string
  is_video: boolean
}

interface GalleryGridProps {
  items: GalleryItem[]
  onEdit: (item: GalleryItem) => void
  onRemove: (item: GalleryItem) => void
}

function GalleryGrid({ items, onEdit, onRemove }: GalleryGridProps) {
  const getMediaUrl = (item: GalleryItem) => {
    return getImageUrl(item.file_path)
  }

  return (
    <div className="gallery-grid">
      {items.map((item) => (
        <div key={item.id} className="gallery-item">
          <div className="gallery-item-media">
            {item.is_video ? (
              <>
                <video src={getMediaUrl(item)} muted />
                <div className="video-indicator">▶</div>
              </>
            ) : (
              <img src={getMediaUrl(item)} alt={item.title || item.file_name} />
            )}
          </div>
          <div className="gallery-item-info">
            <h3 className="gallery-item-title">{item.title || item.file_name}</h3>
            <p className="gallery-item-category">
              {item.category_name || 'Sans catégorie'}
            </p>
          </div>
          <div className="gallery-item-actions">
            <button
              className="edit-btn"
              onClick={() => onEdit(item)}
              title="Modifier"
            >
              ✏️
            </button>
            <button
              className="remove-btn"
              onClick={() => onRemove(item)}
              title="Retirer de la galerie"
            >
              ✕
            </button>
          </div>
        </div>
      ))}
    </div>
  )
}

export default GalleryGrid
